import React from 'react'
import styled, { css } from 'styled-components'
import CheckboxTick from '../../../assets/icons/checkbox-tick.svg'
import { up } from 'styled-breakpoints'
import { pxToRem } from '../../../utils'
import { Caption2, B2, P4 } from '../../Typo'

const Checkbox = ({visible=true, ...props }) => (
  <CheckboxContainer {...props}>
    <HiddenCheckbox {...props} data-testid={props.testId} />
    {props.icon ? (
    props.icon
  ) :(visible?
   (
    <StyledCheckbox {...props} data-testid="styled-checkbox">
      <Tick />
    </StyledCheckbox>
  ):"" )
  }
    
  </CheckboxContainer>
)
const CheckBox = ({ className, ...props }) => {
  const handleCheckboxChange = event => {
    event.stopPropagation()
    props.onChange(event.target.checked)
  }
  return (
    <CheckBoxWrapper
      className={className}
      data-testid="ui-checkbox"
      density={props.density}
      checked={props.checked}
      styledCheckbox={props.styledCheckbox}
    >
      <Label {...props} labelStyling={props?.checkBoxStyling?.checkBoxWrapper}>
        <Checkbox {...props} onChange={handleCheckboxChange} />
        <CheckBoxLabelWrapper>
          <CheckboxLabel
            {...props}
            checked={props.checked}
            labelStyling={props?.checkBoxStyling?.label}
            className="checkbox-label"
          >
            {props.label}
          </CheckboxLabel>
          <CheckboxSecondaryLabel {...props} className="checkbox-label">
            {props.secondaryLabel}
          </CheckboxSecondaryLabel>
        </CheckBoxLabelWrapper>
      </Label>
      {props.error && <ErrorMessage className="error-text">{props.error}</ErrorMessage>}
    </CheckBoxWrapper>
  )
}

export default CheckBox

CheckBox.defaultProps = {
  styledCheckbox: false
}

const getCheckBoxWrapperHeight = density => {
  if (density === 'normal') {
    return '74px'
  } else {
    return 'initial'
  }
}

const CheckBoxLabelWrapper = styled.article`
  display: flex;
  flex-direction: column;
`

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: ${props => getCheckBoxWrapperHeight(props.density)};
  justify-content: center;
  width: auto;
  min-height: 30%;
  ${props =>
    props.styledCheckbox
      ? css`
          border: ${pxToRem(1)} solid
            ${props => (props.checked ? props.theme.palette.burgundy1 : props.theme.palette.grey4)};
          border-radius: ${pxToRem(12)};
          padding: ${pxToRem(4)} ${pxToRem(2)};
          box-shadow: ${props => (props.checked ? '0 2px 20px #ed116429' : '')};
          background-color: ${props => props.theme.palette.white};
        `
      : css`
          border: 0;
          border-radius: 0;
        `}
`

const baseWidthHeight = css`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};

  ${up('md')} {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
  }
`
const styledCheckboxWidthHeight = css`
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};

  ${up('md')} {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
  }
`
const Tick = styled(CheckboxTick)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // Hide checkbox visually but remain accessible to screen readers.
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`
const StyledCheckbox = styled.div`
  ${styledCheckboxWidthHeight};
  box-sizing: border-box;
  position: relative;
  border: 1px solid ${props => getBorderColor(props)};
  display: inline-block;
  transition: all 150ms;
  opacity: ${props => (props.disabled && props.checked ? 0.4 : 1)};
  background: ${props => getBackgroundColor(props)};

  ${props =>
    props.styledCheckbox
      ? css`
          border-radius: ${pxToRem(71)};
          ${up('md')} {
            width: ${pxToRem(24)};
            height: ${pxToRem(24)};
          }
        `
      : css`
          ${up('md')} {
            width: ${pxToRem(18)};
            height: ${pxToRem(18)};
          }
        `}

  ${HiddenCheckbox}:focus + & {
    /* box-shadow: 0 0 4px 0 rgba(237, 17, 100, 0.4); */
  }
  ${Tick} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`
const CheckboxContainer = styled.div`
  /* ${baseWidthHeight}; */
  pointer-events: ${props => (props.disabled ? 'none' : 'inherit')};
  justify-content: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
  ${props =>
    props.icon
      ? css`
          width: ${pxToRem(32)};
          height: ${pxToRem(32)};
        `
      : css`
          width: ${pxToRem(20)};
          height: ${pxToRem(20)};

          ${up('md')} {
            width: ${pxToRem(24)};
            height: ${pxToRem(24)};
          }
        `}
`
const getBorderColor = props => {
  if (props.disabled && props.checked) return props.theme.colors.primary
  if (props.disabled || !props.checked) return props.theme.palette.grey6
  else return props.theme.colors.primary
}

const getBackgroundColor = props => {
  if (props.checked) return props.theme.colors.primary
  else return props.theme.palette.white
}
const getLabelColor = props => {
  if (props.labelColor) return props.labelColor
  else return props.theme.palette.grey1
}
const CheckboxLabel = styled(B2)`
  margin-left: ${pxToRem(8)};
  margin-right: ${pxToRem(4)};
  color: ${props => getLabelColor(props)};
  font-weight: ${props =>
    props?.labelStyling?.fontWeight ? props.labelStyling.fontWeight : props.checked ? 'bold' : 'normal'};
  font-size: ${props => props?.labelStyling?.fontSize || '12px'};
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  ${up('md')} {
    font-size: ${pxToRem(16)};
    margin-left: ${pxToRem(16)};
  }
`

const CheckboxSecondaryLabel = styled(P4)`
  margin-left: ${pxToRem(8)};
  color: ${props => props.theme.palette.grey2};
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  ${up('md')} {
    margin-left: ${pxToRem(16)};
  }
`

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  padding: ${pxToRem(4)};
  ${up('md')} {
    padding: ${props => props?.labelStyling?.padding || '4px'};
  }
`

const ErrorMessage = styled(Caption2)`
  margin-top: ${pxToRem(4)};
  color: ${props => props.theme.palette.red1};
`
